<template>
  <div class="manager_box">
    <div style="margin: 14px">
      <!-- <el-date-picker v-model="value1" type="monthrange" range-separator="至" start-placeholder="默认本月" end-placeholder="默认下个月" @change='date_picker' value-format='timestamp' :clearable='false'> </el-date-picker> -->
      <el-date-picker
        v-model="value1"
        type="month"
        placeholder="选择日期"
        :clearable="false"
        value-format="yyyy-M"
        @change="date_picker"
        style="max-width: 320px"
      ></el-date-picker>
    </div>
    <div class="chart">
      <div
        class="item_range_index"
        v-for="(item, index) in dashboard_list"
        :key="index"
      >
        <p>{{ item.name }}</p>
        <div
          v-loading="dashboard_loading"
          class="Icon_div"
          :id="'dashboard' + index"
          :style="{ width: '300px', height: '300px' }"
        ></div>
        <div class="bottom_message">完成目标情况：{{ item.percentage }}%</div>
      </div>
      <div
        class="barchart_range_index"
        v-if="
          $cookies.get('auth_grade') == 30 || $cookies.get('auth_grade') == 80
        "
      >
        <p>全部实时数据统计</p>
        <div
          v-loading="barchart_loading"
          class="Icon_div"
          id="barchart1"
          :style="{ width: '400px', height: '400px' }"
        ></div>
      </div>
    </div>
    <div class="chart" v-if="$cookies.get('auth_grade') == 100">
      <div class="barchart_range_index">
        <p>ABCD实时数据统计</p>
        <div
          v-loading="barchart_loading"
          class="Icon_div"
          id="barchart"
          :style="{ width: '400px', height: '400px' }"
        ></div>
      </div>
      <div class="barchart_range_index">
        <p>全部实时数据统计</p>
        <div
          v-loading="barchart_loading"
          class="Icon_div"
          id="barchart1"
          :style="{ width: '400px', height: '400px' }"
        ></div>
      </div>
    </div>
    <div
      class="item_range_index"
      v-loading="show_product_all_staff_data_loading"
    >
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="每日职员数据" name="1">

                </el-tab-pane>
                <el-tab-pane label="每月职员数据" name="2">

                </el-tab-pane>
      </el-tabs>-->
      <div style="width: 300px">
        <el-date-picker
          v-model="picker_value"
          type="date"
          placeholder="选择日期"
          value-format="timestamp"
          :clearable="false"
          @change="select_date"
        ></el-date-picker>
      </div>

      <div
        style="width: 100%^; overflow: hidden"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <p>
          {{ item.product_name
          }}{{
            item.product_name == "24猎代理商" ? "数据统计" : "员工数据统计"
          }}
        </p>
        <el-table
          :data="item.staff_data"
          style="width: 100%; margin: 20px"
          show-summary
          :summary-method="getSummaries"
          stripe
        >
          <el-table-column
            prop="staff_name"
            label="姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="A类型客户"
            prop="client_sort_data[0].value"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="B类型客户"
            prop="client_sort_data[1].value"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="C类型客户"
            prop="client_sort_data[2].value"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="D类型客户"
            prop="client_sort_data[3].value"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="私海总数"
            prop="client_sort_data[4].value"
            min-width="100"
          ></el-table-column>
          <!-- <el-table-column label="新客户" prop="follow_status[0].value" min-width="100"> </el-table-column> -->
          <el-table-column
            label="添加微信"
            prop="follow_status[1].value"
            min-width="100"
          ></el-table-column>
          <!-- <el-table-column label="产品演示" prop="follow_status[2].value" min-width="100"> </el-table-column> -->
          <!-- <el-table-column label="电子合同" prop="follow_status[3].value" min-width="100"> </el-table-column> -->
          <!-- <el-table-column label="已签未回" prop="follow_status[4].value" min-width="100"> </el-table-column> -->
          <!-- <el-table-column label="完成" prop="follow_status[5].value" min-width="100"> </el-table-column> -->
          <el-table-column
            label="新增客户"
            prop="today_create_data[0].today"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="接通量"
            prop="today_create_data[1].today"
            min-width="100"
          ></el-table-column>
          <!-- <el-table-column label="今日回访" prop="today_create_data[2].today" min-width="100"> </el-table-column> -->
          <!-- <el-table-column label="今日电话量" prop="today_create_data[3].today" min-width="100"> </el-table-column> -->
          <el-table-column
            label="今日出访量"
            prop="today_create_data[4].today"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="已完成目标"
            prop="target_data.finish_money"
            min-width="100"
          ></el-table-column>
          <el-table-column
            label="目标金额"
            prop="target_data.target_money"
            min-width="100"
          ></el-table-column>
          <el-table-column label="是否完成目标" min-width="120" fixed="right">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.target_data.value < 100 ? 'danger' : 'success'"
              >
                <span v-if="scope.row.target_data.value < 100"
                  >未完成 {{ scope.row.target_data.value }}%</span
                >
                <span v-else>已完成</span>
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      value1: "",
      // 仪表盘数据
      dashboard_list: [],
      dashboard_loading: false,

      // 柱状图数据
      barchart_list: [
        { name: "全部数据", type: "bar", data: [0, 0, 0, 0] },
        { name: "24猎", type: "bar", data: [0, 0, 0, 0] },
        { name: "劳务巴士", type: "bar", data: [0, 0, 0, 0] },
        { name: "渠道", type: "bar", data: [0, 0, 0, 0] },
      ],
      barchart_loading: false,

      tableData: [],
      show_product_all_staff_data_loading: false,

      // activeName: '1'
      picker_value: "",
      index: 0,
    };
  },
  watch: {},
  created() {
    // console.log('本月', new Date(new Date().getFullYear() + "-" + (new Date().getMonth()+1) + "-" + '1 00:00:00 ').getTime())
    // this.picker_value = Date.parse(new Date())
    this.admin_data_management();
    this.show_product_all_staff_data();
  },
  methods: {
    date_picker() {
      console.log("当前的实戳", this.value1);
      this.admin_data_management(1);
    },
    admin_data_management(e) {
      // 获取数据
      let add = this.value1.split("-"),
        Obj = {};
      if (add.length == 2) {
        Obj = {
          // month_start_time: this.value1[0]/1000,
          // month_end_time: this.value1[1]/1000
          year: add[0],
          month: add[1],
        };
      }
      this.dashboard_loading = true;
      this.barchart_loading = true;
      require("post", "/lufish_index_data/v1/admin_data_management/", Obj).then(
        (res) => {
          console.log("内容", res);
          if (!res.code) {
            let that = this;
            this.dashboard_loading = false;
            this.barchart_loading = false;
            res.data.target_deal_data.forEach((item) => {
              if (item.name == "") {
                item.name = "全部数据";
              }
            });
            res.data.client_sort_data.forEach((item) => {
              if (item.name == "") {
                item.name = "全部数据";
              }
              item.type = "bar";
            });
            console.log("内容", this.barchart_list);
            this.dashboard_list = res.data.target_deal_data;
            this.$nextTick(() => {
              that.dashboard();
            });

            if (!e) {
              this.barchart_list = res.data.client_sort_data;

              this.$nextTick(() => {
                that.barchart();
              });
            }
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    show_product_all_staff_data(e) {
      console.log(
        "请求那是处男出纳是",
        this.$cookies.get("agent_company_name") != null
      );
      this.show_product_all_staff_data_loading = true;
      let Obj = {};
      if (e) {
        Obj.search_data = { start_time: e };
      }
      let url = "";
      if (this.$cookies.get("agent_company_name") != null) {
        url = "/lufish_index_data/v1/show_agent_all_staff_data/";
      } else {
        url = "/lufish_index_data/v1/show_product_staff_data/";
      }
      require("post", url, Obj).then((res) => {
        console.log("内容", res);
        if (!res.code) {
          this.tableData = res.data;
          if (this.$cookies.get("agent_company_name") == null) {
            require("post", "/lufish_index_data/v1/show_agent_product_staff_data/", Obj).then(
              (res) => {
                console.log("内容", res);
                if (!res.code) {
                  this.tableData.push(...res.data);
                }
              }
            );
          }
        }
        this.show_product_all_staff_data_loading = false;
      });
    },
    dashboard() {
      // 仪表盘
      let that = this;
      console.log(this.dashboard_list);
      this.dashboard_list.forEach((item, index) => {
        let dashboard_name = "dashboard" + index;
        console.log(dashboard_name, item);
        window[dashboard_name] = this.$echarts.init(
          document.getElementById("dashboard" + index + "")
        );
        window[dashboard_name].setOption({
          tooltip: {
            formatter: function (value) {
              // console.log('内容', value)
              return (
                "业绩指标：" +
                value.data.target_money +
                "<br>完成金额：" +
                value.data.finish_money +
                "(" +
                value.data.percentage +
                "%)"
              );
            },
          },
          toolbox: {
            // feature: {
            //     restore: {},
            //     saveAsImage: {}
            // }
          },
          series: [
            {
              // max: (item.target_money/10000).toFixed(2),
              max: item.target_money,
              // max: 200,
              splitNumber: 2, //刻度数量
              name: "业务指标",
              type: "gauge",
              axisLine: {
                lineStyle: {
                  width: 20, // 这个是修改宽度的属性
                },
              },
              detail: {
                offsetCenter: ["0", "90"],
                formatter: function (val) {
                  return item.finish_money;
                },
              },
              data: [item],
            },
          ],
        });
      });
    },
    barchart() {
      // 数据统计
      let that = this,
        add = [],
        list = JSON.parse(JSON.stringify(this.barchart_list));
      let barchart_for1 = this.$echarts.init(
        document.getElementById("barchart1")
      );

      if (this.$cookies.get("auth_grade") == 100) {
        let barchart_for = this.$echarts.init(
          document.getElementById("barchart")
        );
        console.log(list);
        add = list.filter((item, index) => {
          item.label = { normal: { show: true } };
          console.log(["全部数据", "充值"].indexOf(item.name) == -1);
          return ["全部数据", "充值"].indexOf(item.name) == -1;
        });
        console.log(list, "addddddd");
        barchart_for.setOption({
          color: ["#FF8F00", "#41b883", "#1E90FF", "#DC143C"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            data: ["渠道", "超级管理员", "24猎代理商"],
          },
          xAxis: [
            {
              type: "value",
            },
          ],
          yAxis: [
            {
              type: "category",
              axisTick: { show: false },
              data: ["A", "B", "C", "D"],
            },
          ],
          series: add,
        });
      }
      barchart_for1.setOption({
        color: ["#003366"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["全部数据"],
        },
        xAxis: [
          {
            type: "value",
          },
        ],
        yAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: ["A", "B", "C", "D"],
          },
        ],
        series: [that.barchart_list[0]],
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

    select_date(e) {
      console.log(e);
      this.show_product_all_staff_data(e / 1000);
    },

    getSummaries(param) {
      // let obj = {
      //     name: '1123',
      //     add: [ {name: '789'} ]
      // }
      // let add = obj.add[0].name
      // console.log(param);
      const { columns, data } = param;
      // console.log('columns, data', columns)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        // console.log('column.property', column.property)
        const values = data.map((item) => {
          let name = "." + column.property;
          // console.log('item[column.property]', eval(`item${name}`))
          return Number(eval(`item${name}`));
        });

        // console.log("values", values);

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = "N/A";
        }
      });

      console.log(sums);
      // console.log("最后", sums[10] / sums[11]);
      if (sums[sums.length - 3] != "N/A" && sums[sums.length - 2] != "N/A") {
        if (sums[sums.length - 2] == 0) {
          sums[sums.length - 1] = "未设置目标金额";
        } else {
          sums[sums.length - 1] =
            ((sums[sums.length - 3] / sums[sums.length - 2]) * 100).toFixed(2) +
            "%";
        }

        console.log((sums[sums.length - 3] / sums[sums.length - 2]) * 100);
      } else {
        sums[sums.length - 1] = "0%";
      }
      return sums;
    },
  },
};
</script>

<style>
.chart {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.item_range_index {
  /* border: 1px red solid; */
  border-radius: 10px;
  background: white;
  min-height: 250px;
  margin: 14px;
  padding: 4px 10px;
  box-sizing: border-box;
  /* box-shadow: 6px 6px 20px #888888; */
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
}
.Icon_div {
  margin: 6px auto;
}
.barchart_range_index {
  /* border: 1px red solid; */
  width: 45%;
  border-radius: 10px;
  background: white;
  min-height: 250px;
  margin: 14px;
  padding: 4px 10px;
  box-sizing: border-box;
  /* box-shadow: 6px 6px 20px #888888; */
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
}
.bottom_message {
  text-align: center;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/team_data.vue